export const isPublicSharePage = () => window.location.hash.startsWith('#/share/');

// Also redact old share navigation breadcrumbs after leaving the public page.
export function scrubSharingDiagnostics(value, seen = new WeakSet()) {
  if (typeof value === 'string') return value.replace(/[a-f0-9]{64}/gi, '[share-token-redacted]');
  if (!value || typeof value !== 'object' || seen.has(value)) return value;
  seen.add(value);
  for (const key of Object.keys(value)) value[key] = scrubSharingDiagnostics(value[key], seen);
  return value;
}
